import { Heading, HFlow, VFlow } from 'bold-ui'
import { RadioField } from 'components/form'
import { CondicaoMaternalFiltroEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { condicaoMaternalFiltroRecord } from '../../model/model-acompanhamentoCondicaoSaude'

interface AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupFieldProps {
  meta: MetaPath<CondicaoMaternalFiltroEnum>
}

export function AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupField(
  props: Readonly<AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupFieldProps>
) {
  const { meta } = props

  return (
    <VFlow>
      <Heading level={3}>Condição maternal</Heading>
      <HFlow alignItems='center'>
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.TODAS}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.TODAS]}
        />
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.GESTANTE}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.GESTANTE]}
        />
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.PUERPERA}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.PUERPERA]}
        />
      </HFlow>
    </VFlow>
  )
}
